const HOSTNAME = window.location.hostname;
const LOCALHOST = 'localhost';

const API_URL_LOCAL = `${import.meta.env.VITE_API_URL_LOCAL || 'http://localhost:3001'}/graphql`;
const API_URL = `${import.meta.env.VITE_API_URL}/graphql`;

export const getBaseUrl = () => {
  if (HOSTNAME.includes(LOCALHOST)) {
    return API_URL_LOCAL;
  }

  return API_URL;
};
